import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";
import { DeleteContentError, handleXcoreError } from "@robe/core-api/errors";

/**
 * @throws {DeleteContentError}
 */
export const deleteContent = (contentId: number, core: XcoreCore): BaseApiRequest<void> =>
  core.fetch(`/api/content/${contentId}`, { method: "DELETE" }).then((res, url) => {
    !res.ok && handleDeleteContentError(url, res);
  });

export const handleDeleteContentError = handleXcoreError((...args) => new DeleteContentError(...args));
